import styled from 'styled-components';

export const RightBlockMainWrap = styled.div(
  props => `
        width: 73%;
        display: flex;
        min-height: 900px;
        @media (max-width: 768px){
            width:100%;
            max-width:90%;
            margin: 1.5rem auto;
        }
    `,
);

export const RightInnerWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `,
);
